import { DatePipe, NgOptimizedImage } from '@angular/common';
import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import { ActivatedRoute, RouterLink } from '@angular/router';
import { WEB_CONFIG, WebAppEnvironment } from '@buspro/web/core';
import confetti from 'canvas-confetti';

const CONFETTI_COLORS = ['#0072BC', '#38bdf8', '#60a5fa', '#34d399', '#fbbf24', '#f87171', '#818cf8', '#fb923c'];
const CONFETTI_DURATION_MS = 4000;

@Component({
  selector: 'tenant-account-setup-success',
  templateUrl: './account-setup-success.component.html',
  styleUrls: ['./account-setup-success.component.scss'],
  standalone: true,
  imports: [RouterLink, NgOptimizedImage, DatePipe],
})
export class AccountSetupSuccessComponent implements OnInit, OnDestroy {
  private readonly route = inject(ActivatedRoute);
  protected readonly environment = inject<WebAppEnvironment>(WEB_CONFIG);

  userName = '';
  currentDate = new Date();
  websiteUrl = this.environment.publicWebsiteUrl;

  private confettiTimer: ReturnType<typeof setTimeout> | null = null;
  private animationFrameId: number | null = null;
  private confettiCanvas: HTMLCanvasElement | null = null;
  private myConfetti: ReturnType<typeof confetti.create> | null = null;

  ngOnInit() {
    const { name } = this.route.snapshot.queryParams;
    this.userName = name ?? '';

    // Create a dedicated canvas above the success-page overlay (z-index: 99999)
    this.confettiCanvas = document.createElement('canvas');
    Object.assign(this.confettiCanvas.style, {
      position: 'fixed',
      top: '0',
      left: '0',
      width: '100%',
      height: '100%',
      zIndex: '99999',
      pointerEvents: 'none',
    });
    document.body.appendChild(this.confettiCanvas);
    this.myConfetti = confetti.create(this.confettiCanvas, { resize: true, useWorker: false });

    this.confettiTimer = setTimeout(() => this.launchSchoolPride(), 400);
  }

  private launchSchoolPride() {
    const endTime = Date.now() + CONFETTI_DURATION_MS;
    const fire = this.myConfetti!;

    const frame = () => {
      // Left cannon
      fire({
        particleCount: 3,
        angle: 60,
        spread: 55,
        origin: { x: 0, y: 0.65 },
        colors: CONFETTI_COLORS,
      });
      // Right cannon
      fire({
        particleCount: 3,
        angle: 120,
        spread: 55,
        origin: { x: 1, y: 0.65 },
        colors: CONFETTI_COLORS,
      });

      if (Date.now() < endTime) {
        this.animationFrameId = requestAnimationFrame(frame);
      } else {
        // Final centre shower after the side cannons finish
        fire({
          particleCount: 120,
          spread: 130,
          startVelocity: 28,
          decay: 0.93,
          origin: { x: 0.5, y: 0.1 },
          colors: CONFETTI_COLORS,
        });
      }
    };

    this.animationFrameId = requestAnimationFrame(frame);
  }

  ngOnDestroy() {
    if (this.confettiTimer) clearTimeout(this.confettiTimer);
    if (this.animationFrameId) cancelAnimationFrame(this.animationFrameId);
    if (this.myConfetti) this.myConfetti.reset();
    if (this.confettiCanvas) document.body.removeChild(this.confettiCanvas);
  }
}
